import { Component, OnInit } from '@angular/core';
import { InputService } from './input.service';

@Component({
   selector: 'app-input',
   templateUrl: './input.component.html',
   styleUrls: ['./input.component.less']
})
export class InputComponent implements OnInit {

   show: any = {};

   constructor( private servicioInput: InputService ) { }

   ngOnInit() {
      this.servicioInput.input.subscribe(valor => {
         // @ts-ignore
         if ( valor.tipo !== undefined ) {

            // @ts-ignore
            switch( valor.tipo ) {
               case 1:
                  // @ts-ignore
                  this.show.formato = valor.datos.formato; 
                  // @ts-ignore
                  this.show.limite = valor.datos.limite;
                  // @ts-ignore
                  this.show.texto = valor.datos.texto;
                  // @ts-ignore
                  this.show.titulo = valor.datos.titulo;
                  // @ts-ignore
                  this.show.titulo_secundario = valor.datos.titulo_secundario;
                  // @ts-ignore
                  this.show.cesta_adjuntos = valor.datos.cesta_adjuntos;
                  // @ts-ignore
                  this.show.adjuntos = valor.datos.adjuntos;
                  // @ts-ignore
                  this.show.readonly = valor.datos.readonly;
                  // @ts-ignore
                  this.show.nullable = valor.datos.nullable;
                  // @ts-ignore
                  this.show.placeholder = valor.datos.placeholder;
                  // @ts-ignore
                  this.show.icono_adicional = valor.datos.icono_adicional;
               break;
            }

            // @ts-ignore
            this.show.input = valor.tipo;
         }
      });

      this.servicioInput.eventoInput.subscribe(event => {
         this.show.input = 0;
      })
   }

   eventoTerminadoPizarra($event) {
      this.servicioInput.emitirEvento( { tipo: 1, evento: 1, dato: $event } );
   }
   eventoAdicionalPizarra() {
      this.servicioInput.emitirEvento( { tipo: 1, evento: 2 } );
   }
   eventoCerrarPizarra() {
      this.servicioInput.emitirEvento( { tipo: 1, evento: 0 } );
   }
}
